import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer?: string;
};

type HookTuple = [
  response: vp.EftWithdrawTransactionResponse,
  fetchData: (params: vp.TransactionRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchEFTWithdrawTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.TransactionRequest>({
    TransactionID: '',
    Timezone: 'UTC',
  });
  const [response, setResponse] = useState<vp.EftWithdrawTransactionResponse>({
    ErrorMessage: '',
    Success: false,
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    TransactionDateTime: '',
    HoldReleaseDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    ScheduledTransactionID: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    RecipientName: '',
    DOB: '',
    PhoneNumber: '',
    Email: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    ClientReferenceNumber: '',
    ParentTransaction: [],
    LastModified: '',
    ABARoutingNumber: '',
    IBAN: '',
    Iq11: '',
    KYCPerformed: '',
    KYCReferenceNumber: '',
    SortCode: '',
    ParentTransactionID: '',
    FailureReason: '',
    GLCode: '',
    WireReferenceNumber: '',
    TransactionTypeCode: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen', true);

      const res = await api.fetchEFTWithdrawTransaction(params, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'processing', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (params: vp.TransactionRequest) => {
      setParams(params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        ErrorMessage: '',
        Success: false,
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        TransactionDateTime: '',
        HoldReleaseDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        ScheduledTransactionID: '',
        FirstName: '',
        LastName: '',
        CompanyName: '',
        RecipientName: '',
        DOB: '',
        PhoneNumber: '',
        Email: '',
        Address1: '',
        Address2: '',
        City: '',
        Province: '',
        Country: '',
        PostalCode: '',
        FinancialInstitutionNumber: '',
        BranchTransitNumber: '',
        AccountNumber: '',
        ClientReferenceNumber: '',
        ParentTransaction: [],
        LastModified: '',
        ABARoutingNumber: '',
        IBAN: '',
        Iq11: '',
        KYCPerformed: '',
        KYCReferenceNumber: '',
        SortCode: '',
        ParentTransactionID: '',
        FailureReason: '',
        GLCode: '',
        WireReferenceNumber: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchEFTWithdrawTransaction);
